import { styled } from 'styled-components';

export const NovaSenhaPageContainer = styled.div`

`;